import { createRoutineCreator } from 'redux-saga-routines';

// ADD     payload: { type: 'patient', id, serverEntity } — stocke l'entité serveur pour application directe
// RESOLVE payload: { type, id, strategy: 'use_server', serverEntity } — bumpe remountKeys pour contacts
// APPLIED — efface l'entité serveur après application dans FicheClinique
const createConflictsRoutine = createRoutineCreator(['ADD', 'RESOLVE', 'APPLIED']);
export const conflictsRoutine = createConflictsRoutine('CONFLICTS');
